export default "__VITE_PUBLIC_ASSET__b832690e__"